/**
 *
 * useCustomFavicon
 *
 */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _has from 'lodash/has';
import { makeSelectClientDetails } from 'containers/Main/selectors';

function useCustomFavicon() {
  const clientDetails = useSelector(makeSelectClientDetails());

  useEffect(() => {
    // Skip for bare embed assessment pages
    const isBareEmbed =
      typeof window !== 'undefined' && _get(window, 'xprops.type') === 'bare';
    const isAssessmentPage =
      typeof window !== 'undefined' &&
      window.location.pathname.startsWith('/assessments/');

    if (isBareEmbed && isAssessmentPage) {
      return; // No need to set favicon for bare embed assessments
    }

    const hasCustomFavicon = _has(clientDetails, 'metadata.customFavicon');
    if (hasCustomFavicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = _get(clientDetails, 'metadata.customFavicon');
    }
  }, [clientDetails]);
}

export default useCustomFavicon;
